/**
 * The WPD wholesale login page (/apps/wpdapp/wholesale/login) is rendered by the
 * app, so its password field can't be edited in the theme. The store uses
 * passwordless login — submitting with the field blank works — so this relabels
 * the app-rendered field to say a password isn't needed, and removes the
 * required constraint so the hint is truthful.
 */
(function () {
  var pw = document.getElementById('CustomerPassword');
  if (!pw) return;
  var tag = document.querySelector('script[src*="wholesale-login-hint.js"]');
  var hint = (tag && tag.getAttribute('data-hint')) || 'No password needed — just leave this blank';
  pw.setAttribute('placeholder', hint);
  pw.removeAttribute('required');
  pw.removeAttribute('aria-required');
})();
